export default __webpack_public_path__ + "static/media/iconDjango.74087fa9.svg";